module.exports = __webpack_public_path__ + "static/img/3.e446aec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/3.png
// module id = RvQH
// module chunks = 0